const APPS = [
    {id: "capybara", name: "Capybara", url: "https://capybara.rs"},
    {id: "splatos", name: "Splatos", url: "https://splatos.artembo.com"},
    {id: "other", name: "Other"},
];

export default APPS;
